const config = require("config");

(function () {
  "use strict";

  angular
    .module("alk.maps")
    .factory("mapService", mapService);
  mapService.$inject = ["$rootScope", "ALKMaps"];

  function mapService($rootScope, ALKMaps) {
    var mapElem = {};
    var mapObj = null;
    var editZoom = 16;

    var service = {
      addControl: addControl,
      removeControl: removeControl,
      addLayer: addLayer,
      canEditMap: canEditMap,
      deregisterEvent: deregisterEvent,
      getMap: getMap,
      getStyle: getStyle,
      getZoom: getZoom,
      initializeMap: initializeMap,
      destroyMap: destroyMap,
      registerEvent: registerEvent,
      releaseMap: releaseMap,
      removeLayer: removeLayer,
      resizeMap: resizeMap,
      safePanTo: safePanTo,
      setCenter: setCenter,
      setStyle: setStyle,
      zoomIn: zoomIn,
      zoomOut: zoomOut,
      zoomTo: zoomTo,
      zoomToEdit: zoomToEdit,
      getEditZoomLevel: getEditZoomLevel
    };

    return service;

    function addControl(name, mapControlObj, activate) {
      mapObj.addControls([mapControlObj]);
      if (activate) {
        mapControlObj.activate();
      }
    }

    function removeControl(mapControlObj) {
      mapObj.removeControl(mapControlObj);
    }

    function addLayer(name, mapLayerObj) {
      mapObj.addLayers([mapLayerObj]);
    }

    function deregisterEvent(evtName, callback) {
      mapObj.events.unregister(evtName, mapObj.map, callback);
    }

    function registerEvent(evtName, callback) {
      mapObj.events.register(evtName, mapObj.map, callback);
    }

    function initializeMap(map) {
      if (mapObj == null) {
        mapObj = new ALKMaps.Map();
        mapObj.displayProjection = new ALKMaps.Projection("EPSG:4326");
        mapObj.routeElements = [];
      }
    }

    function releaseMap() {
      $rootScope.$broadcast("releaseMap", {
        center: mapObj.getCenter(),
        zoom: mapObj.getZoom(),
        style: getStyle()
      });

      mapObj.mapStyle = "default";
    }

    function destroyMap() {
      if (mapObj != null) {
        mapObj.destroy();
        mapObj = null;
      }
    }

    function getMap() {
      return mapObj;
    }

    function getZoom() {
      return mapObj.getZoom();
    }

    function resizeMap() {
      if (mapObj != null)
        mapObj.updateSize();
    }

    //A normal, smooth transition pan can cause issues flicking back to the panned spot if trying to manually pan after
    function safePanTo(lonlat, zoom) {
      mapObj.zoomTo(4);
      mapObj.panTo(lonlat);
      mapObj.zoomTo(zoom);
    }

    function zoomTo(zoom) {
      mapObj.zoomTo(zoom);
    }

    function setCenter(center, zoomLevel = 5) {
      mapObj.setCenter(center, zoomLevel);
    }

    function setStyle(style) {
      if (mapObj.baseLayer) {
        if (style === "satellite_only") {
          mapObj.baseLayer.satelliteOnly = true;
          mapObj.baseLayer.changeStyle("satellite");
        } else {
          if (mapObj.baseLayer.satelliteOnly) delete mapObj.baseLayer.satelliteOnly;
          mapObj.baseLayer.changeStyle(style);
        }
      }
    }

    function getStyle() {
      if (mapObj.baseLayer.satelliteOnly && mapObj.baseLayer.params.STYLE === "satellite") {
        return "satellite_only";
      } else {
        return mapObj.baseLayer.params.STYLE;
      }
    }

    function removeLayer(layerObj) {
      mapObj.removeLayer(layerObj);
    }

    function zoomIn() {
      mapObj.zoomIn();
    }

    function zoomOut() {
      mapObj.zoomOut();
    }

    function canEditMap() {
      if (!getMap()) return false;
      return getMap().getZoom() >= editZoom;
    }

    function getEditZoomLevel() {
      return editZoom;
    }

    function zoomToEdit() {
      zoomTo(editZoom);
    }
  }
})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/map.service.js